import client from '@/lib/http/client';

export const fetchReportData = async (
	id: string,
	filter: string[] = [],
): Promise<any> => {
	return (await client.get(`/reports/data/${id}`)).data;
};
